export default __webpack_public_path__ + "static/media/delete.e546dbf0.svg";